export default __webpack_public_path__ + "04713a85af5938deec0eb390cbe6aaf3.jpg";